import { autoinject } from 'aurelia-framework';
import { AuthHttpClient } from './auth-http-client';
import { Models } from 'models/core';
import { RopeTypeService } from 'models/RopeTypeService';
import { NettingTypeService } from 'models/NettingTypeService';
import { LoopTypeService } from 'models';

@autoinject
export class ServiceProductService {
  constructor(private httpClient: AuthHttpClient) {}

  public async getDisinfectionTypes(serivceStep: string, serviceId: number) {
    const disinfectionAPIUrl = 'api/serviceproducts/disinfectiontypes';
    return await this.httpClient.execWithResponseMeta<Models.DisinfectionType[]>(
      `${disinfectionAPIUrl}/${serivceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getDetergentTypes(serivceStep: string, serviceId: number) {
    const disinfectionAPIUrl = 'api/serviceproducts/detergentTypes';
    return await this.httpClient.execWithResponseMeta<Models.DetergentType[]>(
      `${disinfectionAPIUrl}/${serivceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getImpregnationTypes(serviceStep: string, serviceId: number) {
    const impregnationAPIUrl = 'api/serviceproducts/impregnationTypes';
    return await this.httpClient.execWithResponseMeta<Models.ImpregnationType[]>(
      `${impregnationAPIUrl}/${serviceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getRopeTypeService(serviceStep: string, serviceId: number) {
    const ropeTypeServiceAPIUrl = 'api/serviceproducts/ropeTypeService';
    return await this.httpClient.execWithResponseMeta<RopeTypeService[]>(
      `${ropeTypeServiceAPIUrl}/${serviceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getPackagingTypesService(serviceStep: string, serviceId: number) {
    const packagingTypesServiceAPIUrl = 'api/serviceproducts/packagingTypesService';
    return await this.httpClient.execWithResponseMeta<Models.PackagingTypeService[]>(
      `${packagingTypesServiceAPIUrl}/${serviceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getNettingTypesService(serviceStep: string, serviceId: number) {
    const nettingTypesServiceAPIUrl = 'api/serviceproducts/nettingTypesService';
    return await this.httpClient.execWithResponseMeta<NettingTypeService[]>(
      `${nettingTypesServiceAPIUrl}/${serviceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getLoopTypesService(serviceStep: string, serviceId: number) {
    const loopTypesServiceAPIUrl = 'api/serviceproducts/loopTypesService';
    return await this.httpClient.execWithResponseMeta<LoopTypeService[]>(
      `${loopTypesServiceAPIUrl}/${serviceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }

  public async getSewingThreadTypesService(serviceStep: string, serviceId: number) {
    const sewingThreadTypesServiceAPIUrl = 'api/serviceproducts/sewingThreadTypesService';
    return await this.httpClient.execWithResponseMeta<Models.SewingThreadTypeService[]>(
      `${sewingThreadTypesServiceAPIUrl}/${serviceStep}/${serviceId}`,
      {
        method: 'GET',
      }
    );
  }
}
